import { CURRENT_TOS_VERSION } from 'src/constants';

/**
 * Checks if a given TOS version string is valid
 * @param {string} accepted_tos_version - The TOS version to validate
 * @returns {boolean} - True if the TOS version is current or MSA is not expired
 */
export const isTosValid = (accepted_tos_version) => {
    if (!accepted_tos_version) return false;

    // Check if it's the current version
    if (accepted_tos_version === CURRENT_TOS_VERSION) return true;

    // Check if it's an MSA format "MSA Expires MM/DD/YYYY"
    const msaMatch = accepted_tos_version.match(/MSA Expires (\d{2}\/\d{2}\/\d{4})/);
    if (msaMatch) {
        const expirationDate = new Date(msaMatch[1]);
        return expirationDate > new Date();
    }

    return false;
};

/** Role that can accept the Terms of Service on a group's behalf. */
export const MINING_ACCOUNT_OWNER_ROLE = 'mining_account_owner';

/**
 * The user's groups where they hold the Group Owner role, sorted alphabetically
 * by group name. Only this role can accept the ToS for a group, so these are the
 * only groups the ToS gate and dialog ever act on.
 * @param {object} loggedInUser
 * @returns {Array} owner-role group items (possibly empty)
 */
export const getOwnerRoleGroups = (loggedInUser) =>
    (loggedInUser?.groups || [])
        .filter(groupItem => groupItem.userRole?.roleName === MINING_ACCOUNT_OWNER_ROLE)
        .sort((a, b) => a.group.name.localeCompare(b.group.name));

/**
 * Whether the user must accept an updated ToS before using the app: true when they
 * hold the Group Owner role on at least one group whose accepted ToS version is
 * stale. Single source of truth for the DashboardLayout gate and the dialog's group
 * list, so the two can never drift.
 * @param {object} loggedInUser
 * @returns {boolean}
 */
export const userMustAcceptTos = (loggedInUser) =>
    getOwnerRoleGroups(loggedInUser).some(
        groupItem => !isTosValid(groupItem.group.accepted_tos_version)
    );
